import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (19.495 / 24);
  const localHeight = size * (23 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 19.495 23">
      <g transform="translate(-3522 -7064)">
        <path
          d="M639.3,1483.521a.821.821,0,0,1-.821-.811l-.036-3c0-4.047,2.116-7.516,5.187-8.6a6.248,6.248,0,1,1,9.013-.037c3.121,1.024,5.293,4.532,5.293,8.624l0,3a.821.821,0,0,1-.821.822Zm5.157-10.951-.027.008c-2.518.721-4.346,3.715-4.346,7.12l.027,2.181H656.3l0-2.181c0-3.406-1.827-6.4-4.345-7.12l-.914-.286a6.241,6.241,0,0,1-5.79.022Zm-.945-5.8a4.606,4.606,0,1,0,4.605-4.6A4.611,4.611,0,0,0,643.516,1466.768Z"
          transform="translate(2883.554 5603.479)"
          fill={localColor}
        />
      </g>
    </svg>
  );
};

export default Index;
